import { useQuery } from '@tanstack/react-query';
import { loanPipelineApi, type PipelineSummary } from '../api/services/loan-pipeline';

export function useLoanPipeline() {
  return useQuery<PipelineSummary>({
    queryKey: ['admin', 'pipeline', 'summary'],
    queryFn: () => loanPipelineApi.getSummary(),
  });
}
